const BASE_URL = 'https://wh-fe.au-aws.thewishlist.io/api/v1/store-front/wishlist'
const BASE_URL_CUSTOMER = 'https://wh-fe.au-aws.thewishlist.io/api/v1/store-front/customer'
const customerId = GM_STATE?.customer?.id || ''
const shopHash = window.Shopify.shop.replace('.myshopify.com', '')
const currency = window.Shopify.currency.active

const defaultHeaders = {
  'Content-Type': 'application/json'
}

const fetchJSON = async (url, options = {}) => {
  try {
    const res = await fetch(url, { headers: defaultHeaders, ...options })

    if (!res.ok) throw new Error(`Request failed: ${res.status}`)

    return await res.json()
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('Wishlist API error:', err)

    return null
  }
}

const getWishlist = async () =>
  fetchJSON(`${BASE_URL}/all?shop_hash=${shopHash}&owner=${customerId}&currency=${currency}`)

const addNewWishlist = async (payload) => {
  const newPayload = {
    ...payload,
    owner: String(customerId),
    shop_hash: shopHash
  }

  return fetchJSON(`${BASE_URL}`, {
    method: 'POST',
    body: JSON.stringify(newPayload)
  })
}

const addProductToWishlist = async (payload) => {
  const newPayload = {
    ...payload,
    owner: String(customerId),
    shop_hash: shopHash
  }

  return fetchJSON(`${BASE_URL}/add-product-to-wishlist`, {
    method: 'POST',
    body: JSON.stringify(newPayload)
  })
}

const removeProductInWishlist = async (payload) => {
  const newPayload = {
    ...payload,
    shop_hash: shopHash
  }

  return fetchJSON(`${BASE_URL}/remove-product-in-wishlist`, {
    method: 'POST',
    body: JSON.stringify(newPayload)
  })
}

const checkAccountExist = async (id) => {
  const res = await fetch(`${BASE_URL_CUSTOMER}/${id}?shop_hash=${shopHash}`, {
    headers: defaultHeaders,
    method: 'GET'
  })

  if (res.status === 404) return false
  
  let data = null

  try {
    data = await res.json()
  } catch (_) {
    data = null
  }

  if (!res.ok) {
    // Wishlist Co have inconsistent responses here, need to handle seemingly random HTTP 500 in addition to 404.
    // Without this, some customers do not get created on Wishlist Co side and thus cannot add products to their wishlist.
    const errorText = JSON.stringify(data || {})

    if (
      res.status === 500 &&
      (errorText.includes('Customer not found'))
    ) {
      return false
    }

    throw new Error(`Request failed: ${res.status}`)
  }

  return Boolean(data?.data)
}

const correctNewAccount = async (id) => {
  const payload = {
    shop_hash: shopHash
  }

  const res = await fetch(`${BASE_URL_CUSTOMER}/${id}?shop_hash=${shopHash}`, {
    headers: defaultHeaders,
    method: 'POST',
    body: JSON.stringify(payload)
  })

  if (res.status === 404) return false
  if (!res.ok) throw new Error(`Request failed: ${res.status}`)

  return res.json()
}

const getShareWishlist = async (id) => fetchJSON(`${BASE_URL}/share?shop_hash=${shopHash}&id=${id}`)

const getDetailWishlistShare = async (hash) => fetchJSON(`${BASE_URL}/share/detail?hash=${hash}`)

export {
  checkAccountExist,
  getWishlist,
  addProductToWishlist,
  removeProductInWishlist,
  getShareWishlist,
  addNewWishlist,
  getDetailWishlistShare,
  correctNewAccount
}
